import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  RouterModule, Routes, provideRouter } from '@angular/router';
import { CustomMycompanyComponent } from '../custom-landing/custom-mycompany/custom-mycompany.component';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { AuthGuard, ConfigModule, provideConfig, RoutingConfig } from '@spartacus/core';
import { CustomGroupcompaniesComponent } from '../custom-landing/custom-groupcompanies/custom-groupcompanies.component';
import { CustomContactsComponent } from '../custom-landing/custom-contacts/custom-contacts.component';
import { CustomCompanyDetailsComponent } from '../custom-landing/custom-company-details/custom-company-details.component';
import { CustomBhpteamComponent } from '../custom-landing/custom-bhpteam/custom-bhpteam.component';
import { CustomMyqoutesComponent } from '../custom-landing/custom-myqoutes/custom-myqoutes.component';
import { MyContractsComponent } from '../custom-landing/my-contracts/my-contracts.component';
import { CustomProductsComponent } from '../custom-landing/custom-products/custom-products.component';
import { CustomUpdateProfileComponent } from '../custom-header-footer/custom-update-profile/custom-update-profile.component';
import { CustomAddressbookComponent } from '../custom-landing/custom-addressbook/custom-addressbook.component';
import { CustomErrorComponent } from 'src/app/shared/components/custom-error/custom-error.component';
import { CustomMyquotesDetailsComponent } from '../custom-landing/custom-myquotes-details/custom-myquotes-details.component';
import { CustomUpdatePasswordComponent } from '../custom-login/custom-update-password/custom-update-password.component';
import { CustomEditcontactComponent } from '../custom-landing/custom-editcontact/custom-editcontact.component';
import { CustomAddcontactComponent } from '../custom-landing/custom-addcontact/custom-addcontact.component';
import { MfaAuthenticationComponent } from '../custom-login/mfa-authentication/mfa-authentication.component';
import { CustomResetPasswordComponent } from '../custom-login/custom-reset-password/custom-reset-password.component';
import { QuotesComponent } from '../custom-landing/quotes/quotes-router.component';
import { CustomInventoryManagementComponent } from '../custom-landing/custom-inventory-management/custom-inventory-management.component';
import { CustomInventoryDetailsComponent } from '../custom-landing/custom-inventory-details/custom-inventory-details.component';
import { CustomFAQComponent } from '../custom-landing/custom-faq/custom-faq.component';
import { CustomInventoryLoginComponent } from '../custom-login/custom-inventory-login/custom-inventory-login.component';
import { CustomInventoryUpdatePasswordComponent } from '../custom-login/custom-inventory-update-password/custom-inventory-update-password.component';
import { SessionGuard } from 'src/app/shared/guards/session.guard';
//import { CustomInventoryLoginComponent } from '../custom-landing/custom-inventory-login/custom-inventory-login.component';
//import { InventoryAuthGuard } from 'src/app/shared/guards/inventory-auth.guard';
import { ShipmentComponent } from '../custom-landing/shipment/shipment.component';
import { ShipmentDetailsComponent } from '../custom-landing/shipment-details/shipment-details.component';
import { TenderComponent } from 'src/app/modules/custom-landing/tender/tender.component';
import { CustomHomeMenusComponent } from '../custom-landing/custom-home-menus/custom-home-menus.component';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonInterceptorInterceptors } from 'src/app/core/interceptors/common-interceptors.interceptor';
import { CustomASMLoginComponent } from '../custom-login/custom-asmlogin/custom-asmlogin.component';
import { ShipmentVmsListComponent } from '../custom-landing/shipment-vms/shipment-vms-list/shipment-vms-list.component';
import { ShipmentVmsDetailsComponent } from '../custom-landing/shipment-vms/shipment-vms-details/shipment-vms-details/shipment-vms-details.component';
import { DvlTrackingDetailsComponent } from '../custom-landing/shipment-vms/dvl-tracking/dvl-tracking-details/dvl-tracking-details.component';
import { DvlTrackingListComponent } from '../custom-landing/shipment-vms/dvl-tracking/dvl-tracking-list/dvl-tracking-list.component';
import { BatchesScreeningDetailsComponent } from '../custom-landing/shipment-vms/batches-screening-details/batches-screening-details.component';
import { BiometricAndSecurityComponent } from '../custom-header-footer/biometric-and-security/biometric-and-security.component';
import { ConsignmentsListComponent } from '../custom-landing/consignments/consignments-list/consignments-list.component';
import { ShipsRailAndConsignmentListComponent } from '../custom-landing/ships_rail_and_consignment/ships-rail-and-consignment-list/ships-rail-and-consignment-list.component';
import { ShipsRailDetailsComponent } from '../custom-landing/ships_rail_and_consignment/ships-rail-details/ships-rail-details.component';
import { ShipsConsignmentDetailsComponent } from '../custom-landing/ships_rail_and_consignment/ships-consignment-details/ships-consignment-details.component';
import { QualityInspectionComponent } from '../custom-landing/shipment-vms/quality-inspection/quality-inspection.component';
import { QualityInspDetailsComponent } from '../custom-landing/shipment-vms/quality-inspection/quality-insp-details/quality-insp-details.component';
import { BilateralCargoListComponent } from '../custom-landing/bilateral-cargos/bilateral-cargo-list/bilateral-cargo-list.component';

const ROUTES_STATIC: Routes =
  [
    
    {
      path: '',
      component: CustomHomeMenusComponent,
      canActivate: [CmsPageGuard, AuthGuard]
    },
    {
      path:'help',
      component: CustomFAQComponent,
      canActivate: [CmsPageGuard , AuthGuard],
      data:{pageLabel:'help', breadcrumb: 'help', translation: 'breadcrumb.helppage'}
    },
    {
      path: 'reset-password',
      component: CustomResetPasswordComponent,
      //canActivate: [CmsPageGuard],
      data: { pageLabel: 'resetPassword', breadcrumb: 'Reset password', translation: 'breadcrumb.resetpassword' }
    },
    {
      path: 'ASM',
      component: CustomASMLoginComponent,
    },
    {
      path: 'groupcompanies/companyDetails',
      component: CustomCompanyDetailsComponent,
      canActivate: [CmsPageGuard],
      data: { pageLabel: 'homepage' }
    },
    {
      path: 'contacts',
      component: CustomContactsComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'homepage' }
    },
    {
      path: 'my-account/update-profile',
      component: CustomUpdateProfileComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'homepage' }

    },
    {
      path: 'mycontracts',
      component: MyContractsComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'mycontractsPage', breadcrumb: 'Contracts', translation: 'breadcrumb.contracts' }
    },
    // {
    //   path: 'inventorymanagement',
    //   component: CustomInventoryManagementComponent,
    //   canActivate: [CmsPageGuard, AuthGuard],
    //   data: {pageLabel: 'inventorymanagementPage', breadcrumb: 'Inventory Management', translation: 'breadcrumb.im'}
    // },
    {
      path: 'bhpteam',
      component: CustomBhpteamComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'bhpTeamPage', breadcrumb: 'BHP team', translation: 'breadcrumb.bhpTeamMembers' }
    },
    {
      path: 'consignment',
      component: ConsignmentsListComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'consignmentPage', breadcrumb: 'consignments', translation: 'breadcrumb.consignments' }
    },
    {
      path: 'shipmentvms',
      component: QuotesComponent,
      canActivate: [AuthGuard],
      data: { pageLabel: 'shipmentvms', breadcrumb: 'shipmentvms', translation: 'breadcrumb.shipmentvms' },
      children: [
        {
          path: '', redirectTo: 'shipmentvmslist', pathMatch: 'full',
          data: { pageLabel: 'shipmentvms',breadcrumb: 'shipmentvms', translation: 'breadcrumb.shipmentvms' }
        },
        {
          path: 'shipmentvmslist/:data',
          component: ShipmentVmsListComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: { pageLabel: 'shipmentvms',breadcrumb: 'shipmentvms', translation: 'breadcrumb.shipmentvms'},
        },
        {
          path: 'vmsdetails/:id/:data',
          component: ShipmentVmsDetailsComponent,
          canActivate: [AuthGuard],
          data: { pageLabel: 'vmsdetails',breadcrumb: 'shipmentListDetail', translation:'breadcrumb.shipmentListDetail'},
        },
        {
          path: 'quality-inspection',
          component: QualityInspectionComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: { pageLabel: 'qualityInspection',breadcrumb: 'qualityInspection', translation: 'breadcrumb.qualityInspection'},
        },{
          path: 'quality-details/:data/:id/:code',
          component:QualityInspDetailsComponent ,
          canActivate: [AuthGuard],
          data: { pageLabel: 'vmsdetails',breadcrumb: 'qualityInspection', translation:'breadcrumb.qualityInspection'},
        },
      ]
    },
    {
      path: 'shipmentinspection',
      component: QuotesComponent,
      canActivate: [AuthGuard],
      data: { pageLabel: 'shipmentinspection', breadcrumb: 'shipmentinspection', translation: 'breadcrumb.shipmentinspection' },
      children: [
        {
          path: '', redirectTo: 'shipmentinspectionlist', pathMatch: 'full',
          data: { pageLabel: 'shipmentinspection',breadcrumb: 'shipmentinspection', translation: 'breadcrumb.shipmentinspection' }
        },
        {
          path: 'shipmentinspectionlist/:data',
          component: ShipmentVmsListComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: { pageLabel: 'shipmentinspection',breadcrumb: 'shipmentinspection', translation: 'breadcrumb.shipmentinspection'},
        },
      ]
    },

    {
      path: 'batches',
      component: QuotesComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'batches', breadcrumb: 'batches', translation: 'breadcrumb.batches' },
      children: [
        {
          path: '', redirectTo:'dvl-tracking-list', pathMatch: 'full',
          data: { pageLabel: 'batches' }
        },
        {
          path: 'dvl-tracking-list',
          component: DvlTrackingListComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: { pageLabel: 'batches'},
        },
       

        {
          path: 'dvl-tracking-details/:id',
          component: DvlTrackingDetailsComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: { pageLabel: 'batchdetails'},
        },
       
      ]
    },
    {
      path: 'dvl-screening-list',
      component: QuotesComponent,
      canActivate: [AuthGuard],
      data: { pageLabel: 'batches', breadcrumb: 'batches', translation: 'breadcrumb.batches' },
      children: [
        {
          path: '', redirectTo: 'dvl-screening-list', pathMatch: 'full',
          data: { pageLabel: 'batches',breadcrumb: 'batches', translation: 'breadcrumb.batches' }
        },
        {
          path: 'dvl-screening-list/:data',
          component: DvlTrackingListComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: { pageLabel: 'batches'},
        },
        {
          path: 'batches-screening/:id/:data',
          component: BatchesScreeningDetailsComponent,
          canActivate: [AuthGuard],
          data: {pageLabel: 'batchesscreeningdetails'},
        },
      ]
    },
    {
      path: 'quotes',
      component: QuotesComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'homepage', breadcrumb: ' Bids & offers ' , translation: 'breadcrumb.bids&offers'},
      children: [
        {
          path: '', redirectTo: 'myquotes', pathMatch: 'full',
          //canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'bidsAndOffersPage' }
        },
        {
          path: 'myquotes',
          component: CustomMyqoutesComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'bidsAndOffersPage' }
        },
        {
          path: 'myquotes/:quoteId',
          component: CustomMyquotesDetailsComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'bidsAndOffersPage', breadcrumb: `Details`, translation: 'breadcrumb.bidsDetails' }
        }
      ]
    },
    {
      path: 'myquotes/:quoteId',
      component: CustomMyquotesDetailsComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'bidsAndOffersPage' }
    },
    {
      path: 'contact/:contactId',
      component: CustomEditcontactComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'homepage'  }
    },
    {
      path: 'products',
      component: CustomProductsComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'homepage' }
    },

    {
      path: 'error',
      component: CustomErrorComponent,
      // canActivate: [CmsPageGuard, AuthGuard],
      data: { pageLabel: 'errorPage' }
    },
    {
      path: 'companies',
      component: QuotesComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      // data: { pageLabel: 'homepage', breadcrumb: ' My company ', translation: 'breadcrumb.mycompany' },
      children: [
        {
          path: '', redirectTo: 'myCompany', pathMatch: 'full',
          //canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'homepage' }
        },
        {
          path: 'myCompany',
          component: CustomMycompanyComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'homepage' }
        },
        {
          path: 'myCompany/groupcompanies',
          component: QuotesComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'homepage', breadcrumb: 'Group companies ', translation: 'breadcrumb.groupcompany'  },
          children:
            [
              {
                path: '', redirectTo: 'detail', pathMatch: 'full',
                //canActivate: [CmsPageGuard, AuthGuard],
                data: { pageLabel: 'groupCompaniesPage' }
              },
              {
                path: 'detail',
                component: CustomGroupcompaniesComponent,
                canActivate: [CmsPageGuard, AuthGuard],
                data: { pageLabel: 'groupCompaniesPage' },
              },
              {
                path: 'detail/updateDetails',
                component: CustomCompanyDetailsComponent,
                canActivate: [CmsPageGuard, AuthGuard],
                data: { pageLabel: 'updateCompanyDetailsPage', breadcrumb: 'Update my company details', translation: 'breadcrumb.updateCompanyDetails' }
              },
            ]
        },
        {
          path: 'myCompany/addressBook',
          component: QuotesComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'homepage', breadcrumb: 'Address book ', translation: 'breadcrumb.addressBook' },
          children:
            [
              {
                path: '', redirectTo: 'detail', pathMatch: 'full',
                //canActivate: [CmsPageGuard, AuthGuard],
                data: { pageLabel: 'addressBookPage' }
              },
              {
                path: 'detail',
                component: CustomAddressbookComponent,
                canActivate: [CmsPageGuard, AuthGuard],
                data: { pageLabel: 'addressBookPage' },
              },
            ]
        },
        {
          path: 'myCompany/contacts',
          component: QuotesComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'homepage', breadcrumb: 'Contacts ', translation: 'breadcrumb.contactsList' },
          children:
            [
              {
                path: '', redirectTo: 'detail', pathMatch: 'full',
                //canActivate: [CmsPageGuard, AuthGuard],
                data: { pageLabel: 'contactsPage' }
              },
              {
                path: 'detail',
                component: CustomContactsComponent,
                canActivate: [CmsPageGuard, AuthGuard],
                data: { pageLabel: 'contactsPage' },
              },
              {
                path: 'detail/Update/:contactId',
                component: CustomEditcontactComponent,
                canActivate: [CmsPageGuard, AuthGuard],
                data: { pageLabel: 'contactsPage', breadcrumb : 'Update contact', translation: 'breadcrumb.updateContact'}
              },
              {
                path: 'detail/add',
                component: CustomAddcontactComponent,
                canActivate: [CmsPageGuard, AuthGuard],
                data: { pageLabel: 'addContactsPage', breadcrumb : 'Add new contact', translation: 'breadcrumb.addNewContact'}
              },
            ]
        },

      ]
    },
    {
      path: 'profile',
      component: QuotesComponent,
      canActivate: [CmsPageGuard, AuthGuard],
      // data: { pageLabel: 'homepage', breadcrumb: ' My account ', translation: 'breadcrumb.myAccount' },
      children: [
        // uncmment and change the myaccount component if any
        {
          path: '', redirectTo: 'my-account', pathMatch: 'full',
          //canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'homepage' }
        },
        {
          path: 'my-account',
          component: CustomProductsComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'homepage' }
        },
        {
          path: 'my-account/update-personal-details',
          component: CustomUpdateProfileComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'updatePersonalDetailsPage', breadcrumb: 'Update personal details', translation: 'breadcrumb.updatepersonaldetails' },
        },
        {
          path: 'my-account/biometric-and-security',
          component: BiometricAndSecurityComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'biometricAndSecurityPage', breadcrumb: 'Biometrics and security'},
        },
        {
          path: 'my-account/change-password',
          component: CustomUpdatePasswordComponent,
          canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'changePasswordPage', breadcrumb: 'Reset password', translation: 'breadcrumb.resetpassword' }
        },


      ]
    },
    {
      path: 'login/otp',
      component: MfaAuthenticationComponent,
      //canActivate: [CmsPageGuard],
      data: { pageLabel: 'otpPage', breadcrumb: 'One time password', translation: 'breadcrumb.otp' }
    },
    // {
    //   path: 'inventory/inventorymanagement',
    //   component: CustomInventoryManagementComponent,
    //   canActivate: [CmsPageGuard, SessionGuard],
    //   //canActivate: [CmsPageGuard],
    //   data: {pageLabel: 'inventorymanagementPage', breadcrumb: 'Inventory Management', translation: 'breadcrumb.im'},
    //   children: [
    //     {
    //       path: 'details',
    //       component: CustomInventoryDetailsComponent,
    //       canActivate: [CmsPageGuard,SessionGuard],
    //       data: {pageLabel: 'inventoryDetailsPage', breadcrumb: 'Update personal details', translation:''}
    //     }
    //   ]
    // },
    // {
    //   path: 'inventory/inventorydetailspages',
    //   component: CustomInventoryDetailsComponent,
      

      //canActivate: [CmsPageGuard],
     // canActivate: [CmsPageGuard, SessionGuard],
      //data: {pageLabel: 'inventoryDetailsPage'}
    //},
    //{
     // path: 'inventory/inventorylogin',
      //component: CustomInventoryLoginComponent, 
      // component: CustomMycompanyComponent,
    //  canActivate: [CmsPageGuard],
    //  data: {  pageLabel: 'inventoryLogin',breadcrumb: 'inventoryLogin', translation: 'breadcrumb.inventorylogin'}
    //},
    //{
    //  path: 'inventory/inventoryupdatepassword',
    //  component: CustomInventoryUpdatePasswordComponent, 
    //  // component: CustomMycompanyComponent,
    //  canActivate: [CmsPageGuard],
    //  data: {  pageLabel: 'inventoryUpdatePassword', breadcrumb: 'updatePassword', translation: 'breadcrumb.updatepassword'}
    //},
    {
      path:'opentenders',
      component:TenderComponent,
      canActivate: [CmsPageGuard,AuthGuard],
      data: {pageLabel: 'tenderpage',breadcrumb: ' Invitation to bid ', translation:'breadcrumb.InvitationOfBid'},  
    },
    {
        path:'bilateralCargos',
        component:BilateralCargoListComponent,
        canActivate: [CmsPageGuard,AuthGuard],
        data: {pageLabel: 'cargosListpage',breadcrumb: ' Bilateral Cargos', translation:'breadcrumb.bilateralCargo'},
      },
    {
      path: 'shipment',
      component: QuotesComponent,
      canActivate: [CmsPageGuard,AuthGuard],
      data: {pageLabel: 'homepage' ,breadcrumb: ' Shipments & documents ', translation:'breadcrumb.shipments'},
      children: [
        {
          path: '', redirectTo: 'shipmentProduct', pathMatch: 'full',
          //canActivate: [CmsPageGuard, AuthGuard],
          data: { pageLabel: 'shipment' }
        },
        {
          path: 'shipmentProduct',
          component: ShipmentComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: { pageLabel: 'shipment'},
        },
        {
          path: 'details',
          component: ShipmentDetailsComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: {pageLabel: 'shipment-details', breadcrumb: ' Details ', translation: 'breadcrumb.details'} 
        },
        {
          path: 'rails',
          component: ShipsRailAndConsignmentListComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: {pageLabel: 'shipment-rails', breadcrumb: ' Shipments & documents ', translation: 'breadcrumb.rails'} 
        },
        {
          path: 'shipconsignments',
          component: ShipsRailAndConsignmentListComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: {pageLabel: 'shipment-consignments', breadcrumb: ' Shipments & documents ', translation: 'breadcrumb.Shipconsign'} 
        },
         {
          path: 'raildetails/:id',
          component: ShipsRailDetailsComponent,
          canActivate: [CmsPageGuard,AuthGuard],
          data: { pageLabel: 'raildetails',breadcrumb: 'Details', translation:'breadcrumb.raildetails'},
        },
        {
          path: 'shipconsigndetails/:id',
          component: ShipsConsignmentDetailsComponent,
          canActivate: [AuthGuard],
          data: { pageLabel: 'shipconsigndetails',breadcrumb: 'Details', translation:'breadcrumb.shipconsigndetails'},
        }
      ]
    },
    // {
    //   path: '**',
    //   component: CustomBhpteamComponent,
    //   canActivate: [ AuthGuard],
    //   data: { pageLabel: 'bhpTeamPage', breadcrumb: 'BHP team', translation: 'breadcrumb.bhpTeamMembers' }
    // }

  ];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(ROUTES_STATIC,{onSameUrlNavigation:'reload'}),
    RouterModule.forChild(ROUTES_STATIC),
    ConfigModule.withConfig({
      routing: {
        routes: {
          groupcompanies: {
            paths: ['groupcompanies'],
          },
          contacts: {
            paths: ['contacts'],
          },
          companyDetails: {
            paths: ['groupcompanies/companyDetails'],
          },
          addcontact: {
            paths: ['contacts/addcontact'],
          },
          updatecontact: {
            paths: ['contacts/updatecontact'],
          },
          shipment:{
            paths: ['shipment']
          },
          myquotes: {
            paths: ['myquotes'],
          },
          bhpteam: {
            paths: ['bhpteam'],
          },
          myContracts: {
            paths: ['mycontracts'],
          },
          // inventoryManagement: {
          //   paths: ['inventory/inventorymanagement'],
          // },
          // inventoryDetails: {
          //   paths: ['inventory/inventorydetailspages'],
          // },

          products: {
            paths: ['products'],
          },
          addressbooks: {
            paths: ['addressbooks'],
          },
          resetPassword: {
            paths: ['my-account/reset-password']
          },
          error: {
            paths: ['error'],
          },
          shipmentvms:{
            paths:['shipmentvms']
          },
          batches:{
            paths:['batches']
          },
          shipmentinspection:{
            paths:['shipmentinspection']
          },
          dvlscreeninglist:{
            paths:['dvl-screening-list']
          },
           consignment:{
            paths:['consignment']
          },
           rails:{
            paths:['rails']
          },
          shipconsignments:{
            paths:['shipconsignments']
          },
          raildetails:{
            paths:['raildetails']
          },
        }
      }
    } as RoutingConfig),
  ],
  providers:[provideRouter(ROUTES_STATIC),provideClientHydration(),provideHttpClient(withInterceptorsFromDi()),{
    provide:HTTP_INTERCEPTORS,useClass:CommonInterceptorInterceptors,multi:true,
  }, provideConfig(<RoutingConfig>{
      routing: {
        routes: {
          login: {
            paths: ['login'],
            protected: false,
            authFlow: true,
          },
        },
      },
    }),],
})
export class CustomRoutingModule { }
